const RITA_LOGIN_MESSAGE_TYPE = "kompact:rita-login";
const RITA_LOGIN_STORAGE_KEY = "ritaLoginResult";
const RITA_LOGIN_RESULT_MAX_AGE_MS = 5 * 60 * 1000;

function safeRedirectPath(value) {
    const path = typeof value === "string" ? value.trim() : "";
    return path.startsWith("/") && !path.startsWith("//") && !path.includes("\\") ? path : "/";
}

function selectAssignedCompany(selectedCompany, assignedCompanies = []) {
    const companies = Array.isArray(assignedCompanies) ? assignedCompanies.filter(Boolean) : [];
    return companies.includes(selectedCompany) ? selectedCompany : (companies[0] || "");
}

function openRitaLoginWindow(browserWindow, url) {
    const width = 520;
    const height = 720;
    const screen = browserWindow.screen || {};
    const left = Math.max(0, Math.round(((screen.availWidth || width) - width) / 2));
    const top = Math.max(0, Math.round(((screen.availHeight || height) - height) / 2));
    const features = [
        "popup=yes",
        `width=${width}`,
        `height=${height}`,
        `left=${left}`,
        `top=${top}`,
        "resizable=yes",
        "scrollbars=yes",
    ].join(",");
    const popup = browserWindow.open(url, "rita-login", features);

    if (!popup) {
        browserWindow.location.assign(url);
        return null;
    }

    if (typeof popup.focus === "function") popup.focus();
    return popup;
}

function buildRitaLoginUrl(origin, redirectPath = "/") {
    const query = new URLSearchParams({
        return_origin: new URL(origin).origin,
        redirect_url: safeRedirectPath(redirectPath),
    });
    return `/api/auth/rita/login?${query.toString()}`;
}

function parseRitaCallback(query = {}) {
    return {
        userId: typeof query.rita_uid === "string" ? query.rita_uid : "",
        error: typeof query.rita_error === "string" ? query.rita_error : "",
        redirectPath: safeRedirectPath(query.redirect_url),
    };
}

function serializeRitaLoginResult(query = {}, createdAt = Date.now()) {
    const callback = parseRitaCallback(query);
    return JSON.stringify({
        type: RITA_LOGIN_MESSAGE_TYPE,
        ...callback,
        createdAt,
    });
}

function parseRitaLoginResult(value, now = Date.now()) {
    try {
        const result = typeof value === "string" ? JSON.parse(value) : value;
        const createdAt = Number(result?.createdAt);
        if (
            result?.type !== RITA_LOGIN_MESSAGE_TYPE
            || (!result?.userId && !result?.error)
            || !Number.isFinite(createdAt)
            || createdAt > now + 30_000
            || now - createdAt > RITA_LOGIN_RESULT_MAX_AGE_MS
        ) return null;

        return {
            type: RITA_LOGIN_MESSAGE_TYPE,
            userId: typeof result.userId === "string" ? result.userId : "",
            error: typeof result.error === "string" ? result.error : "",
            redirectPath: safeRedirectPath(result.redirectPath),
            createdAt,
        };
    } catch (_) {
        return null;
    }
}

module.exports = {
    RITA_LOGIN_MESSAGE_TYPE,
    RITA_LOGIN_STORAGE_KEY,
    buildRitaLoginUrl,
    openRitaLoginWindow,
    parseRitaCallback,
    parseRitaLoginResult,
    safeRedirectPath,
    selectAssignedCompany,
    serializeRitaLoginResult,
};
